// A4 — Admin-only tour: Workcenter Group. 3 steps on /resources.
export default {
  key: 'A4',
  route: null,
  routePattern: /^\/resources\/workcentergroups\/\d+$/,
  steps: [
    {
      id: 'workcenterGroup',
      target: '[data-tour-id="resources.workcentergroup.general"]',
      title: 'General',
      desc: "General info and behavior settings for the workcenter group. Behavior is controlled by the category (Internal, External, MaterialProvisioning, NonBlocking).",
    },
    {
      id: 'workcenterGroup',
      target: '[data-tour-id="resources.workcentergroup.workcenters"]',
      title: 'Workcenters',
      desc: "Workcenters are the actual machines. Each workcenter has properties for location, capacity and assigned workers.",
    },
    {
      id: 'workcenterGroup',
      target: '[data-tour-id="resources.workcentergroup.action-types"]',
      title: 'Action Types',
      desc: "Action types define the operations that can be performed on the workcenters. You define whether is mandatory and the price per action type.",
    },
  ],
}
